import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import * as profileActions from '../../containers/SignInPage/actions'
import { InitialState as ProfileStateType } from '../../containers/SignInPage/types'
import moment from 'moment'
import { declOfNum } from '../../utils/helpers'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import useHover from '@react-hook/hover'
import $ from 'jquery'

// Styles
import './styles.scss'

// Components
import notification from '../Notification'

// Images
import IconLogoMin from './images/iconLogoMin'
import IconExit from './images/iconExit'
import IconLeaf from './images/iconLeaf'
import IconGeo from './images/iconGeo'
import IconProfile from './images/iconProfile'
import IconCopy from '../ProfileHeader/images/iconCopy'
import IconPopArrow from '../ProfileHeader/images/iconPopArrow'

export default () => {
  const [info, setInfo] = useState<{
    fio: string
    age: string
    role: string
  }>({
    fio: '',
    age: '',
    role: '',
  })

  const dispatch = useDispatch()
  const location = useLocation()

  const isProfilePage = location.pathname.includes('/profile')

  const refCodeButton = useRef<HTMLButtonElement | null>(null)
  const refPopUp = useRef<HTMLDivElement | null>(null)

  const isHovering = useHover(refCodeButton, { enterDelay: 0, leaveDelay: 0 })

  const { profile, currentCourseTitle } = useSelector(
    (state: { profile: ProfileStateType }) => state.profile
  )

  const isAuthed = !!(profile && profile.user_id)

  const { REACT_APP_HEADER_CONTEST_LINK } = process.env

  useEffect(() => {
    if (refPopUp.current) {
      if (isHovering) {
        $(refPopUp.current).fadeIn('fast')
      } else {
        $(refPopUp.current).fadeOut('fast')
      }
    }
  }, [isHovering])

  useEffect(() => {
    if (profile && profile.profile) {
      const wrapFio = []
      let role = ''
      let age = ''

      if (profile.roles && profile.roles[0]) {
        role = profile.roles[0].label
      }
      if (profile.profile.last_name) {
        wrapFio.push(profile.profile.last_name)
      }
      if (profile.profile.first_name) {
        wrapFio.push(profile.profile.first_name)
      }
      if (profile.profile.middle_name) {
        wrapFio.push(profile.profile.middle_name)
      }

      const fio = wrapFio.join(' ')

      if (profile.external_profile?.birthdate) {
        const diffAge = moment().diff(
          profile.external_profile?.birthdate,
          'years'
        )

        age = `${diffAge} ${declOfNum(diffAge, ['год', 'года', 'лет'])}`
      }

      setInfo({ fio, role, age })
    }
  }, [profile])

  const signOut = (): void => {
    dispatch(profileActions.signOut())
  }

  return (
    <header className={'main-header'}>
      <div className={'main-header__leaf'}>
        <IconLeaf />
      </div>
      <div className={'container'}>
        <div className={'main-header__global'}>
          <Link className={'main-header__global-logo'} to="/">
            <IconLogoMin />
          </Link>
          <nav className={'main-header__global-menu'}>
            <div className={'item'}>
              <Link to={'/'} className={'course-name'}>
                {currentCourseTitle ? (
                  currentCourseTitle
                ) : (
                  <>
                    Открой Тайны <br />
                    Семейной Истории
                  </>
                )}
              </Link>
            </div>
            <div className={'item'}>
              <Link className={'item__link item__link-lessons'} to="/">
                Уроки
              </Link>
            </div>
            <div className={'item'}>
              <Link
                className={'item__link item__link-achievements'}
                to="/profile/achievements"
              >
                Достижения
              </Link>
            </div>
            <div className={'item'}>
              <a
                className={'item__link item__link-contest'}
                href={REACT_APP_HEADER_CONTEST_LINK}
                target={'_blank'}
                rel="noreferrer"
              >
                Конкурс
              </a>
            </div>
          </nav>
          <div className={'main-header__global-profile'}>
            <div className={'item-link'}>
              <Link className={'profile-link map'} to={'/'}>
                <IconGeo />
              </Link>
            </div>
            <div className={'item-link'}>
              <Link to={'/profile'} className={'profile-link profile'}>
                <IconProfile />
              </Link>
            </div>
            {isAuthed ? (
              <div className={'item-link'}>
                <button onClick={signOut} className={'profile-link exit'}>
                  <IconExit />
                </button>
              </div>
            ) : null}
          </div>
        </div>
        {isProfilePage ? (
          <div className={'main-header__profile'}>
            <div className={'item-profile'}>
              <div className={'item-profile__status'}>{info.role}</div>
            </div>
            <div className={'item-profile'}>
              <div className={'item-profile__info'}>
                <div className={'name'}>{info.fio}</div>
                {info.age ? <div className={'age'}>{info.age}</div> : null}
              </div>
            </div>
            <div className={'item-profile'}>
              <CopyToClipboard
                text={profile?.external_profile?.short_id || ''}
                onCopy={() =>
                  notification(
                    <IconCopy />,
                    'Ваш ID',
                    'был скопирован!',
                    () => null,
                    () => null,
                    () => null,
                    'copy'
                  )
                }
              >
                <button ref={refCodeButton} className={'item-profile__code'}>
                  ID {profile?.external_profile?.short_id}
                </button>
              </CopyToClipboard>
              <div ref={refPopUp} className={'main-header__profile-popover'}>
                <div className={'main-header__profile-popover-arrow'}>
                  <IconPopArrow className={'icon'} />
                </div>
                Нажмите для копирования ID
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </header>
  )
}
